"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Navigator_1 = require("../../../parts/Navigator");
exports.default = Navigator_1.Navigator;
//# sourceMappingURL=Navigator.js.map